// extracted by mini-css-extract-plugin
export var avatar = "_pl-3";
export var avatarContainer = "_pl-2";
export var avatarSpacer = "_pl-5";
export var avatarSpacerContainer = "_pl-4";
export var avatarStackContainer = "_pl-1";
export var bubble = "_pl-0";
export var remainderBubble = "_pl-6";